// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5235":"21bdaa705c76c636","6766":"ebcc2abd9c9b8681","7210":"183cd806509006ac","7501":"0417e67b76d6518c","8083":"0a6d9a516b553829","8464":"28a363aeff647a2b"}[chunkId] + ".js";
};